import { paging } from "./paging";

/**
 * ### Page Projets
 * - Affiche les push-big des grands projets
 * - Gestion d'un pagination
 * */

export const projects = {
	container: '#projects-list',

	init() {
		// si la var jsonProjectsResult existe
		if (typeof jsonProjectsResult !== 'undefined') {
			console.log('---- liste des projets');
			this.jsonOrigin = jsonProjectsResult;
			//

			// pagination
			// retourne nouveau json & créer le update de la pagination
			paging.init(this.jsonOrigin, 1, 6);

			// Ecoute le changement de page dans la pagination avec un custom event
			document.querySelector('.paging').addEventListener('currentPageChange', (e)=>{
				this.render(e.detail.json);
			})

		}
	},

	render(json) {
		let content = '';

		json.forEach((projet) => {
			let project = new Project(projet);
			content += project.markup;
		});

		document.querySelector(this.container).innerHTML = content;


	}
};

class Project {
	constructor({ img_alt, link_url, img_url, link_target, subhead, title, text, link_title }) {
		this.markup = `
		<div class="seemore seemore__one-push ">
			<div class="seemore__wrapper grid__12col">
				<div class="push push--big dark">
					<a href="${link_url}" target="${link_target}" class="push__wrapper ">
						<div class="push__content">
							<div class="push__subhead wysiwyg">${subhead}</div>
							<div class="push__title wysiwyg">${title}</div>
							<div class="push__txt wysiwyg">${text}</div>
						</div>
						<div class="push__button">
							<div class="link linkIcon">
								<span class="linkIcon__txt">
									<span class="linkIcon__picto"></span>${link_title}</span>
								<span class="linkIcon__picto"></span>
							</div>
						</div>
						<div class="push__img">
							<img src="${img_url}" alt="${img_alt}"/>
						</div>
					</a>
				</div>
			</div>
		</div>`;

		return this.markup;
	}
}
